import styled from 'styled-components'

const DimensionContainer = styled.div`
  padding: 10px;
`

const BannerContainer = styled.div`
  img {
    max-width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`

const DimensionDetailsContainer = styled.div`
  display: flex;
  div {
    flex: 1 0 0;
  }

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    flex-direction: column;
  }
`

const DimensionsDetails = styled.div`
  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    margin-bottom: 20px;
  }
`

const Dimension = styled.div`
  display: flex;
  :not(:first-child) {
    margin-top: 18px;
  }

  div {
    width: 50%;
  }

  div:nth-child(1) {
    font-weight: ${props => props.theme.font.weight.bold};
  }
`

const ButtonsContainer = styled.div`
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  flex-grow: 1;

  button {
    margin-right: 20px;
    flex-grow: 1;
    width: 50%;
  }
`

const DimensionInfomation = styled.div`
  margin-left: 16px;
`

const Heading = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`

export {
  DimensionContainer,
  BannerContainer,
  DimensionDetailsContainer,
  DimensionsDetails,
  DimensionInfomation,
  Dimension,
  ButtonsContainer,
  Heading
}
